import type { ObjectId } from "@bbj-types/utils";
import type { CommunicationType } from "@root/utils/enums/communication";
import { useStableCallback } from "@root/utils/hooks/useStableCallback";
import { axios } from "../../axios";
import type { TPostCandidateFetchBody } from "./types";

export interface IPostCandidatesFetchCommunicationMethods {
  _id: ObjectId;
  firstName: string;
  lastName: string;
  phone?: string;
  optInPhone: boolean;
  mail?: string;
  optInEmail: boolean;
  isEmailValid: boolean;
  communicationType?: CommunicationType;
}

export const usePostCandidatesFetchCommunicationMethods = () => {
  const [state, execute, cancel] = axios<IPostCandidatesFetchCommunicationMethods[], TPostCandidateFetchBody, unknown>(
    {
      url: "/candidates/fetch/communication-methods",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useStableCallback((candidateIds: ObjectId[]) => {
    return execute({
      data: {
        candidateIds,
      },
    });
  });

  return [state, callback, cancel] as const;
};
